// Header js Start
function toggleMenu() {
    document.querySelector('.nav-menu').classList.toggle('active');
  }

function makeTimer() {

	//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
		var endTime = new Date("22 May 2025 9:56:00 GMT+01:00");			
			endTime = (Date.parse(endTime) / 1000);

			var now = new Date();
			now = (Date.parse(now) / 1000);

			var timeLeft = endTime - now;

			var days = Math.floor(timeLeft / 86400); 
			var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
			if (hours < "10") { hours = "0" + hours; }
			if (minutes < "10") { minutes = "0" + minutes; }
			if (seconds < "10") { seconds = "0" + seconds; }

			$("#days").html(days);
			$("#hours").html(hours);
			$("#minutes").html(minutes);
			$("#seconds").html(seconds);		

	}

	setInterval(function() { makeTimer(); }, 1000);
// Header js end

// $(document).ready(function(){
//     $('.add-to-cart-btn').click(function(){
//       $('.drawer').addClass('active');
//     });
// });
  





$(document).ready(function () {
  // Intercept the Add to Cart form submit
  if (!pathname.includes("/products/replacement-filter")) {
  $('form[action="/cart/add"]').on('submit', function (e) {
    e.preventDefault();  

    const $form = $(this);
    const formData = $form.serialize();
console.log(formData);
    // Get current cart count before adding product
    $.getJSON('/cart.js', function(cart) {
      const oldCount = cart.item_count;

      // Add product via AJAX
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (item) {
          console.log('Product added:', item);
          // Open the cart drawer
          openCartDrawer();

          // Wait for the cart count to update, then update UI
          waitForCartCountUpdate(oldCount, 4000, 300);
        },
        error: function (xhr, status, error) {
          console.error('Full error response:', xhr.responseText);          
          console.error('Error adding to cart:', error);
        }
      });
    });
  });
}

  // Function to open cart drawer
  function openCartDrawer() {
    $('body').addClass('overflow-hidden');
    $('.cart-drawer').addClass('active');
    $('.drawer').addClass('active').removeClass('is-empty');
  }

  // Update cart count and drawer content helper
  function updateCartCount(count) {
    if (typeof count === 'undefined') {
      $.getJSON('/cart.js', function(cart) {
        updateCartCount(cart.item_count);
      });
      return;
    }

    $('.cart-count-bubble span[aria-hidden="true"]').text(count);
    $('.cart-count-bubble span.visually-hidden').text(`${count} item${count !== 1 ? 's' : ''}`);

    if (count > 0) {
      $('.cart-count-bubble').show();  // Show bubble if > 0
    } else {
      $('.cart-count-bubble').hide();
    }
  }

  function updateCartDrawer() {
    $.ajax({
      type: 'GET',
      url: '/?section_id=cart-drawer', // fetch updated cart drawer HTML
      success: function (data) {
        const newDrawer = $(data).find('.cart-drawer').html();
        $('.cart-drawer').html(newDrawer);
      },
      error: function (xhr, status, error) {
        console.error('Failed to update cart drawer:', error);
      }
    });
  }

  // Polling function to wait for cart count to change after adding product
  function waitForCartCountUpdate(oldCount, timeout, interval) {
    const startTime = Date.now();

    function check() {
      $.getJSON('/cart.js', function(cart) {
        const newCount = cart.item_count;

        if (newCount !== oldCount) {
          updateCartCount(newCount);
          updateCartDrawer();
        } else if (Date.now() - startTime < timeout) {
          setTimeout(check, interval);
        } else {
          // Timeout reached, update anyway just in case
          updateCartCount(newCount);
          updateCartDrawer();
        }
      });
    }

    check();
  }
});






// $(document).ready(function(){
//   $('.add-to-cart-btn').click(function(){
    
//     $('.drawer').addClass('active');
//     $('body').addClass('overflow-hidden');
//     $('.drawer').removeClass('is-empty');
//   });
// });

$(document).ready(function() {
 
    $(".banner-carousel").owlCarousel({
        loop: false,
        autoPlay: 3000,
        nav: false,
        dots: true,
        autoPlay: false,
        responsive: {
            0: {
                items: 1 
            }
        }
    });
   
});
$('.rc-btn').on('click', function () {
    $('.rc-body').removeClass('active');
    $(this).closest('.rc-body').addClass('active');
});
$('.rc-body:first-child .rc-btn').on('click', function () {
    $('.rc-img').removeClass('active3');
    $('.rc-img').removeClass('active2');
    $('.rc-img').addClass('active1');
});
$('.rc-body:nth-child(2) .rc-btn').on('click', function () {
    $('.rc-img').removeClass('active3');
    $('.rc-img').removeClass('active1');
    $('.rc-img').addClass('active2');
});
$('.rc-body:nth-child(3) .rc-btn').on('click', function () {
    $('.rc-img').removeClass('active2');
    $('.rc-img').removeClass('active1');
    $('.rc-img').addClass('active3');
});

// </span>

const sections = document.querySelectorAll('.timeline-section');
const dots = document.querySelectorAll('.timeline-dot');
const progressLine = document.querySelector('.timeline-progress');
if (progressLine && sections.length > 0) {
window.addEventListener('scroll', () => {
  const scrollTop = window.scrollY + window.innerHeight / 2;

  let activeCount = 0;

  sections.forEach((section, index) => {
    const rect = section.getBoundingClientRect();
    const top = window.scrollY + rect.top;

    if (scrollTop > top) {
      section.classList.add('scrolled');
      activeCount++;
    } else {
      section.classList.remove('scrolled');
    }
  });

  // Fill the timeline line based on progress
  const sectionCount = sections.length;
  const percent = (activeCount - 1) / (sectionCount - 1) * 100;
  progressLine.style.background = `linear-gradient(to bottom, #FFFF00 0%, #FFFF00 ${percent}%, #ccc ${percent}%, #ccc 100%)`;
});
}


// new js
$(document).ready(function() {
  // Initialize all carousels
  $(".dontrust-carousel").each(function() {
      var owl = $(this);
      
      owl.owlCarousel({
          loop: true,
          nav: false,
          dots: false,
          margin: 24,
          responsive: {
              0: {
                  items: 2,
                  // autoWidth: true,
                  // stagePadding: 50,
              },
              576: {
                  items: 2,
              },
              768: {
                  items: 3,
              },
              1100: {
                  items: 4
              }
          }
      });

      // Function to update the slide counter
      function updateCounter(event) {
          var totalSlides = event.item.count; // Total items after carousel is initialized
          var currentIndex = (event.item.index - event.relatedTarget._clones.length / 2) % totalSlides + 1;
          if (currentIndex < 1) currentIndex = totalSlides;

          // Update the specific counter related to the current carousel
          var parentContent = owl.closest(".dont-trust");
          parentContent.find(".current-slide").text(currentIndex.toString().padStart(2, '0'));
          parentContent.find(".total-slides").text(totalSlides.toString().padStart(2, '0'));
      }

      // Set total slides after a small delay to ensure calculation
      setTimeout(function() {
          var totalSlides = owl.find(".owl-item:not(.cloned)").length;
          var parentContent = owl.closest(".dont-trust");
          parentContent.find(".total-slides").text(totalSlides.toString().padStart(2, '0'));
      }, 100); // Delay to ensure correct calculation

      // Update counter on slide change
      owl.on('changed.owl.carousel', updateCounter);
  });

  // Custom Navigation
  $(".custom-prev").click(function() {
      var activeCarousel = $(this).closest(".dont-trust").find(".owl-carousel");
      if (activeCarousel.length) {
          activeCarousel.trigger('prev.owl.carousel');
      }
  });

  $(".custom-next").click(function() {
      var activeCarousel = $(this).closest(".dont-trust").find(".owl-carousel");
      if (activeCarousel.length) {
          activeCarousel.trigger('next.owl.carousel');
      }
  });
});


// $(document).ready(() => {
//   $('.video-wrapper').each((index, container) => {
//     const $video = $(container).find('video');
//     if (!$video.length) return; // Skip if no video element

//     // Ensure video is muted by default
//     $video[0].muted = true;

//     // Play and unmute on mouseenter
//     $(container).on('mouseenter', () => {
//       $video[0].muted = false; // Unmute the video
//       if ($video[0].readyState >= 2) { // Check if video is ready
//         $video[0].play().catch(error => {
//           console.log("Video play on mouseenter failed:", error);
//         });
//       } else {
//         $video.one('loadedmetadata', () => {
//           $video[0].muted = false; // Unmute after metadata loads
//           $video[0].play().catch(error => {
//             console.log("Video play on mouseenter failed after metadata:", error);
//           });
//         });
//       }
//     });

//     $(container).on('mouseleave', () => {
//       $video[0].pause();
//       $video[0].currentTime = 0;
//       $video[0].muted = true; // Mute the video
//     });
//   });
// });


// $(function () {
//   const $carousel = $(".afina-lover-carousel");
// if ($carousel.length) {
//   // 1) Init Owl (v2 option names)
//   $carousel.owlCarousel({
//     loop: false,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     nav: false,
//     dots: false,
//     margin: 24,
//     responsive: {
//       0:   { items: 2 },
//       576: { items: 2 },
//       768: { items: 4 },
//       1100:{ items: 7 }
//     }
//   });

//   // 2) Helpers
//   function setIOSAttrs($v){
//     if (!$v || !$v.length) return;
//     $v.attr({ muted: true, playsinline: true, autoplay: true });
//     // in case markup lacks these:
//     const vid = $v.get(0);
//     vid.muted = true;
//     vid.playsInline = true;
//   }

//   function pauseAllExcept($keep){
//     $carousel.find('video').each(function(){
//       const v = this;
//       if ($keep && v === $keep.get(0)) return;
//       try { v.pause(); } catch(e){}
//       try { v.currentTime = 0; } catch(e){}
//     });
//   }

//   function playFirstVisible(){
//     // .active may include multiple items; pick the first visible with a <video>
//     const $activeItems = $carousel.find('.owl-item.active');
//     let $targetVideo = null;

//     $activeItems.each(function(){
//       const $vid = $(this).find('video').first();
//       if ($vid.length && !$targetVideo) $targetVideo = $vid;
//     });

//     if ($targetVideo && $targetVideo.length){
//       setIOSAttrs($targetVideo);
//       pauseAllExcept($targetVideo);
//       // try to play; ignore iOS promise rejections (e.g., Low Power Mode)
//       $targetVideo.get(0).play().catch(()=>{});
//     } else {
//       // no video in view—pause all just in case
//       pauseAllExcept(null);
//     }
//   }

//   // 3) Wire up Owl events
//   $carousel.on('initialized.owl.carousel', playFirstVisible);
//   $carousel.on('changed.owl.carousel', playFirstVisible);

//   // 4) Pause when carousel is off-screen; resume when back
//   if ('IntersectionObserver' in window) {
//     const io = new IntersectionObserver((entries)=>{
//       entries.forEach(entry=>{
//         if (!entry.isIntersecting) {
//           pauseAllExcept(null);
//         } else {
//           playFirstVisible();
//         }
//       });
//     }, { threshold: 0.2 });
//     io.observe($carousel.get(0));
//   }

//   // 5) Prime all videos with safer defaults (once)
//   $carousel.find('video').each(function(){
//     $(this).attr({ preload: 'metadata', loop: true });
//     setIOSAttrs($(this));
//   });
// }
// });
$(document).ready(function(){
  var $carousel = $('.afina-lover-carousel');
  if ($carousel.length) {
    $carousel.slick({
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      responsive: [
       {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          infinite: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          infinite: false
        }
      }
      ]
    });

    function updateMuteIcon(videoEl){
      let muteBtn = $(videoEl).siblings('.mute-button');
      if(videoEl.muted){
        muteBtn.removeClass('unmuted');
        muteBtn.find('.soundoff').show();
        muteBtn.find('.soundon').hide();
      } else {
        muteBtn.addClass('unmuted');
        muteBtn.find('.soundoff').hide();
        muteBtn.find('.soundon').show();
      }
    }

    function playVideo(videoEl, unmute = false){
      // Pause + reset all videos
      $('video').each(function(){
        this.pause();
        this.currentTime = 0;
        this.muted = true;  // mute all by default
        $(this).siblings('.play-button').show();
        $(this).siblings('.pause-button').hide();
        $(this).siblings('.mute-button').hide();
        $(this).closest('.trust-cont').removeClass('is-playing');
        updateMuteIcon(this);
      });

      if(videoEl){
        videoEl.muted = !unmute; // unmute if flag true
        videoEl.play().catch(err => console.log("Autoplay blocked:", err));

        $(videoEl).siblings('.play-button').hide();
        $(videoEl).siblings('.mute-button').show();
        $(videoEl).closest('.trust-cont').addClass('is-playing');

        updateMuteIcon(videoEl); // keep icons in sync
      }
    }

    // ▶️ First video (muted)
    let firstVideo = $('.afina-lover-carousel .slick-slide.slick-current video').get(0);
    playVideo(firstVideo, false);

    // ▶️ Slide change → play muted
    $('.afina-lover-carousel').on('afterChange', function(event, slick, currentSlide){
      let currentVideo = $(slick.$slides[currentSlide]).find('video').get(0);
      playVideo(currentVideo, true);
    });

    // ▶️ Play button click → always play unmuted
    $(document).on('click', '.play-button', function(){
      let video = $(this).siblings('video').get(0);
      playVideo(video, true);
    });

    // ⏸ Pause button
    $(document).on('click', '.pause-button', function(){
      let video = $(this).siblings('video').get(0);
      video.pause();
      $(this).hide();
      $(this).siblings('.play-button').show();
      $(this).closest('.trust-cont').removeClass('is-playing');
    });

    // 🔇/🔊 Mute toggle
    $(document).on('click', '.mute-button', function(){
      let video = $(this).siblings('video').get(0);
      video.muted = !video.muted; // toggle
      updateMuteIcon(video);
    });
  }
});

// $(document).ready(function(){
//   var $carousel = $('.afina-lover-carousel');
//  if ($carousel.length) {
//   $carousel.slick({
//     infinite: true,
//     slidesToShow: 7,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     autoplay: false,
//     responsive: [
//       { breakpoint: 768, settings: { infinite: false, slidesToShow: 1.2 } }
//     ]
//   });

//   function playVideo(videoEl, unmute = false){
//     // Pause + reset all videos
//     $('video').each(function(){
//       this.pause();
//       this.currentTime = 0;
//       this.muted = true;  // mute all by default
//       $(this).siblings('.play-button').show();
//       $(this).siblings('.pause-button').hide();
//       $(this).siblings('.mute-button').hide();
//       $(this).closest('.trust-cont').removeClass('is-playing');
//     });

//     if(videoEl){
//       videoEl.muted = !unmute; // unmute only if flag is true
//       videoEl.play().catch(err => console.log("Autoplay blocked:", err));

//       $(videoEl).siblings('.play-button').hide();
//       $(videoEl).siblings('.mute-button').show();
//       $(videoEl).closest('.trust-cont').addClass('is-playing');

//       if(unmute){
//         $(videoEl).siblings('.mute-button').addClass('unmuted');
//       } else {
//         $(videoEl).siblings('.mute-button').removeClass('unmuted');
//       }
//     }
//   }

//   let firstVideo = $('.afina-lover-carousel .slick-slide.slick-current video').get(0);
//   playVideo(firstVideo, false);

//   $('.afina-lover-carousel').on('afterChange', function(event, slick, currentSlide){
//     let currentVideo = $(slick.$slides[currentSlide]).find('video').get(0);
//     playVideo(currentVideo, true);
//   });

//   $(document).on('click', '.play-button', function(){
//     let video = $(this).siblings('video').get(0);
//     playVideo(video, true);
//   });

//   $(document).on('click', '.pause-button', function(){
//     let video = $(this).siblings('video').get(0);
//     video.pause();
//     $(this).hide();
//     $(this).siblings('.play-button').show();
//     $(this).closest('.trust-cont').removeClass('is-playing');
//   });

//   // $(document).on('click', '.mute-button', function(){
//   //   let video = $(this).siblings('video').get(0);
//   //   if(video.muted){
//   //     video.muted = false;   
//   //     $(this).addClass('unmuted');
//   //   } else {
//   //     video.muted = true; 
//   //     $(this).removeClass('unmuted');
//   //   }
//   // });

//   $(document).on('click', '.mute-button', function(){
//   let video = $(this).siblings('video').get(0);

//   if(video.muted){
//     video.muted = false;   // unmute
//     $(this).addClass('unmuted');

//     // show soundon, hide soundoff
//     $(this).find('.soundoff').hide();
//     $(this).find('.soundon').show();

//   } else {
//     video.muted = true;    // mute
//     $(this).removeClass('unmuted');

//     // show soundoff, hide soundon
//     $(this).find('.soundoff').show();
//     $(this).find('.soundon').hide();
//   }
// });
// }
  
// });


//mobile carousel js vivek 11th august home page

//mobile carousel js vivek 11th august home page
$(document).ready(function () {
   if ($('.home_mobilecustom').length && window.innerWidth <= 768) {
    $('.home_mobilecustom').slick({
      infinite: false,
      arrows: false,
      dots: false,
      centerMode: false,
      slidesToShow: 1.2,
      slidesToScroll: 1
    });
  }

  if ($('.home_mobilecustom2 .wt').length && window.innerWidth <= 768) {
    $('.home_mobilecustom2 .wt').slick({
      infinite: true, // keeps loop going
      slidesToScroll: 1,
      variableWidth: true,
      arrows: false,
      dots: false
    });
  }
//product page caraousel js
  if ($('.afina-lover-carousel1').length) {
    $('.afina-lover-carousel1').slick({
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 5 }
        },
        {
          breakpoint: 992,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 600,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  }
});


// blog carousel
$(document).ready(function() {
    $(".blog-carousel").owlCarousel({
        loop: true,
        autoPlay: 3000,
        nav: false,
        dots: true,
        autoPlay: true,
        responsive: {
            0: {
                items: 1,
            }
        }
    });
});





//vivek 3rd december--------------------

// Run only on this product page
if (window.location.href.includes("/products/shower-filter")) {

    const targetRid = '421d685e-f729-426d-8461-2959fc4f0b2a';

    function tryClick() {
        const el = document.querySelector(`[data-rid="${targetRid}"]`);
        if (el) {
            el.click();
            console.log('Element clicked:', el);
            observer.disconnect(); // stop observing
        }
    }

    // Observe DOM changes
    const observer = new MutationObserver(tryClick);
    observer.observe(document.body, { childList: true, subtree: true });

    // Try once after 300ms
    setTimeout(() => {
        tryClick();
    }, 300);
}



